import { FeedbackOriginatorType } from '@iamexperiences/inproductfeedback';

export enum IPFFeatureArea {
  MyAccount = 'MyAccount',
  MyGroup = 'MyGroups',
}

export enum IPFAppName {
  MyAccount = 'My Account',
  MyGroup = 'My Groups',
}

export const DEFAULT_OCV_APP_ID = 2746;

export const defaultLastSurveyTimeInDays = 90;
export const defaultLastSurveyTimeInSeconds = 24 * 3600 * defaultLastSurveyTimeInDays;
export const defaultSamplingPercentageThresholdSystem = 1;
export const defaultSamplingPercentageThresholdTask = 2;

export enum KnownIPFSurveyName {
  // system initiated feedback survey names
  myaccountsysteminitiated = 'myaccountsysteminitiated',
  mygroupssysteminitiated = 'mygroupssysteminitiated',

  // user initiated feedback survey names
  myaccountgenericuserinitiated = 'myaccountgenericuserinitiated',
  mygroupsgenericuserinitiated = 'mygroupsgenericuserinitiated',

  devicelist = 'device-list',
  organizations = 'organizations',
  settingsandprivacyprivacy = 'settingsandprivacyprivacy',
  settingsandprivacylanguage = 'settingsandprivacylanguage',
  settingsandprivacylanguagepreferredlanguages = 'settingsandprivacylanguagepreferredlanguages',
  settingsandprivacyregiontimezone = 'settingsandprivacyregiontimezone',
  devicelistdisabledevice = 'devicelistdisabledevice',

  mygroupcreategrouptask = 'mygroupcreategrouptask',
  mygroupjoingrouptask = 'mygroupjoingrouptask',
  mygroupaddmembertask = 'mygroupaddmembertask',
  mygroupremovemembertask = 'mygroupremovemembertask',
}

export interface IFeedbackItem {
  surveyId: string;
  hasCustomLabel: boolean;
  ces: {
    enable: boolean;
    strings?: {
      label: string;
    };
  };
  cva: {
    enable: boolean;
    strings?: {
      label: string;
    };
  };
  csat: {
    enable: boolean;
    strings?: {
      label: string;
    };
  };
  lastSurveyTimeInSeconds: number;
  samplingPercentageThreshold: number;
  originatorType: FeedbackOriginatorType;
}

export const feedbackItems: { [id: string]: IFeedbackItem } = {
  [KnownIPFSurveyName.myaccountsysteminitiated]: {
    surveyId: 'ce7622f5-03da-4da1-94ab-d8b3c073b3f3',
    hasCustomLabel: false,
    ces: { enable: false },
    cva: { enable: false },
    csat: { enable: true },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdSystem,
    originatorType: FeedbackOriginatorType.System,
  },
  [KnownIPFSurveyName.mygroupssysteminitiated]: {
    surveyId: '90694b42-04fd-465e-b16b-db67100ce13b',
    hasCustomLabel: false,
    ces: { enable: false },
    cva: { enable: false },
    csat: { enable: true },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdSystem,
    originatorType: FeedbackOriginatorType.System,
  },
  [KnownIPFSurveyName.myaccountgenericuserinitiated]: {
    surveyId: '35119ff8-c76e-43cb-89cd-dd820af4b44a',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.mygroupsgenericuserinitiated]: {
    surveyId: '0f112b7a-4021-4b6b-bafe-d9c95d86246d',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.devicelist]: {
    surveyId: 'a27f21b4-484d-4d30-a4f1-9145ec7fa9c2',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.organizations]: {
    surveyId: 'f7f893bb-ebf8-44bd-adec-00b7f9eb0389',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.settingsandprivacyprivacy]: {
    surveyId: '85cc6244-67cd-40ec-9974-2f8e2c96a0ae',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.settingsandprivacylanguage]: {
    surveyId: '294824ca-6b59-4f57-88fa-d8c34dde1ccb',
    hasCustomLabel: false,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: 0,
    samplingPercentageThreshold: 100,
    originatorType: FeedbackOriginatorType.User,
  },
  [KnownIPFSurveyName.settingsandprivacylanguagepreferredlanguages]: {
    surveyId: '746e6e8a-08fb-47c6-952d-c3b32d4dae46',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.settingsandprivacyregiontimezone]: {
    surveyId: '2ee99b40-3e4a-42d6-8c0f-d136c77f7ef6',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.devicelistdisabledevice]: {
    surveyId: '95112404-e3e2-4f6b-b6b2-07b5616a6345',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.mygroupcreategrouptask]: {
    surveyId: '4e36bb03-8392-4872-8989-0d78b584b641',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.mygroupjoingrouptask]: {
    surveyId: 'a0d1bb10-a4b0-4832-83b9-3c94faa1b689',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.mygroupaddmembertask]: {
    surveyId: '9153f4c5-3d61-457b-abd3-ede62499bd89',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
  [KnownIPFSurveyName.mygroupremovemembertask]: {
    surveyId: '19f9288f-e9de-492f-b953-1c1948fbb7a1',
    hasCustomLabel: true,
    ces: { enable: true },
    cva: { enable: true },
    csat: { enable: false },
    lastSurveyTimeInSeconds: defaultLastSurveyTimeInSeconds,
    samplingPercentageThreshold: defaultSamplingPercentageThresholdTask,
    originatorType: FeedbackOriginatorType.Task,
  },
};

export const IPFBrowserStorageOverrideKey = {
  // The main purpose of this key is to override whether System Initiated IPF / Task Initiated IPF should be enabled or not
  // This is helpful as it allows us to disable this feature to avoid interference with e2e tests in general by default and to enable it only for a specifc e2e test instead of
  // having to specify a list of test tenants to exclude this from which is tedious and doesn't scale well
  SystemInitiatedIPF: {
    key: 'SystemInitiatedIPFOverrideVisibilityState',
  },
  TaskInitiatedIPF: {
    key: 'TaskInitiatedIPFOverrideVisibilityState',
  },
};
